import { get } from "./api_helper";

// GET /api/messaging/me/keywords → use the sender NAME (not the optional MO
// keyword) as the dropdown value, normalized to [{ shortcode }].
export const getShortcodes = () =>
  get("messaging/me/keywords").then((rows) => {
    const list = Array.isArray(rows) ? rows : [];
    const seen = new Set();
    const out = [];
    for (const r of list) {
      const name = r?.senderName || r?.sender?.name || r?.sender;
      if (!name || seen.has(name)) continue;
      seen.add(name);
      out.push({ shortcode: name, senderId: r.senderId, keyword: r.keyword, active: r.active });
    }
    return out;
  });
